import { motion } from "framer-motion";

const partners = [
    { name: "Digale", logo: "/img/hayatlogol2.png" },
    { name: "Bile", logo: "/img/bile1.png" },
    { name: "Hayat", logo: "/img/digale1.png" },
    { name: "Macruuf", logo: "/img/macruf1.png" },
    { name: "Madrasah", logo: "/img/madrasah1.png" },
    { name: "Saafi", logo: "/img/SAAB.png" },
    { name: "Ubad", logo: "/img/ubad1.png" },
    { name: "Logo 15", logo: "/img/logo15.png" },
];

export default function Partners() {
    return (
        <section className="py-20 bg-background overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
                <div className="text-center max-w-2xl mx-auto">
                    <motion.h3
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="text-neon font-bold tracking-widest text-sm uppercase mb-4"
                    >
                        Our Partners
                    </motion.h3>
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.1 }}
                        className="text-3xl md:text-5xl font-display font-black text-slate-900 mb-6"
                    >
                        We work with the best partners
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                        className="text-slate-600 text-lg"
                    >
                        We collaborate with leading companies to build digital solutions that drive growth and innovation.
                    </motion.p>
                </div>
            </div>

            <div className="relative w-full overflow-hidden">
                <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-background to-transparent z-10" />
                <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-background to-transparent z-10" />

                <motion.div
                    className="flex gap-16 items-center w-max"
                    animate={{ x: ["0%", "-50%"] }}
                    transition={{
                        repeat: Infinity,
                        ease: "linear",
                        duration: 30,
                    }}
                >
                    {[...partners, ...partners].map((partner, index) => (
                        <div key={index} className="flex-shrink-0 px-8">
                            <div className="flex items-center justify-center h-16 md:h-20 w-auto min-w-[150px]">
                                <img
                                    src={partner.logo}
                                    alt={partner.name}
                                    className="h-full w-auto object-contain"
                                />
                            </div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
